import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video/inksquadITA.mp4'
import _imports_1 from '@/assets/video/inksquadENG.mp4'


const _withScopeId = n => (_pushScopeId("data-v-12f33060"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "backdrop-filter backdrop-blur-sm fixed overflow-hidden inset-0 bg-black bg-opacity-50",
  id: "video-modal"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "#fff",
  xmlns: "http://www.w3.org/2000/svg",
  viewbox: "0 0 24 24",
  width: "24px",
  height: "24px"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex justify-center items-center align center m-auto h-full" }
const _hoisted_5 = {
  key: 0,
  class: "popup-video relative",
  src: _imports_0,
  autoplay: "autoplay",
  controls: ""
}
const _hoisted_6 = {
  key: 1,
  class: "popup-video relative",
  src: _imports_1,
  autoplay: "autoplay",
  controls: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close-button flex fixed right-10 top-8 text-white cursor-pointer p-2 rounded-3xl",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      style: {"z-index":"9999"}
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      (/^it.*/.test(_ctx.$i18n.locale))
        ? (_openBlock(), _createElementBlock("video", _hoisted_5))
        : _createCommentVNode("", true),
      (/^en.*/.test(_ctx.$i18n.locale))
        ? (_openBlock(), _createElementBlock("video", _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}